import { styled, Stack } from '@mui/material';
import { DialogContent } from '../../../ui-tmp';

export const Content = styled(DialogContent)({
  paddingBottom: 20,
});

export const StepperContainer = styled(Stack)({
  alignItems: 'center',
  paddingBottom: 24,
});
